import { SimpleCrudController } from '../../../components/simpleCrud/simpleCrud.controller';
import Field, {
  FieldApparence,
  FieldValidation
} from '../../../components/simpleCrud/field.class';
import { Assistant } from '../assistants/assistants.controller';
import { Offer } from '../offers/offers.controller';
import SCTranslations from '../../../components/simpleCrud/SCTranslations.class';

export interface Shop {
  name: String;
  assistants: Assistant[];
  assistantList: boolean[];
  availableOffers: Offer[];
  availableOfferList: boolean[];
}

export default class ShopsController extends SimpleCrudController {
  model: Shop = {
    name: '',
    assistants: [],
    assistantList: [],
    availableOffers: [],
    availableOfferList: []
  };

  errors = {};
  submitted = false;

  translations: SCTranslations = new SCTranslations({
    listTitle: 'LBL_SHOPS',
    // newTitle: 'LBL_NEW_ASSISTANT',
    listIsEmpty: 'LBL_NO_SHOPS_FOUND',
    newTitleNoData: 'LBL_FIRST_NEW_SHOP'
  });
  fields = [
    new Field('name', 'text'),
    new Field('user', 'text'),
    new Field('assistants', 'array'),
    new Field('assistantList', 'array', {
      apparence: new FieldApparence({ fullwidth: false }),
      validation: new FieldValidation({ required: false }),
      removeOnSave: true
    }),
    new Field('availableOffers', 'array'),
    new Field('availableOfferList', 'array', {
      apparence: new FieldApparence({ fullwidth: false }),
      validation: new FieldValidation({ required: false }),
      removeOnSave: true
    }),
    new Field('cabinList', 'array', {
      apparence: new FieldApparence({ fullwidth: false }),
      validation: new FieldValidation({ required: false }),
      removeOnSave: true
    }),
    new Field('hasCabin1', 'checkbox', {
      validation: new FieldValidation({ required: false })
    }),
    new Field('hasCabin2', 'checkbox', {
      validation: new FieldValidation({ required: false })
    }),
    new Field('hasCabin3', 'checkbox', {
      validation: new FieldValidation({ required: false })
    }),
    new Field('hasCabin4', 'checkbox', {
      validation: new FieldValidation({ required: false })
    })
  ];
  /*@ngInject*/
  constructor(Shop, $timeout) {
    super($timeout);
    this.service = Shop;
  }
  getNewModel() {
    return <Shop>this.newModel;
  }
}



// WEBPACK FOOTER //
// ./client/app/manager/shops/shops.controller.ts